import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/scenting-warehouse/stats',
)({
    component: () => (
        <LotStatsPage
            kind="scenting"
            title={m.nav_scenting_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="scenting_lots.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_grade()}
        />
    ),
})
